





import {WConfTpl, WidgetDefinition, WParamTpl} from '@/components/widgets/WidgetFather'
import {bus} from '@/main'
import {datePeriodStartDate, getTodayYYYYMMDD, toYYYYMMDD} from "@/data/sources/dates"
import {formatNumberWithGrouping} from "@/data/sources/numbers"
import {defineComponent} from "@vue/composition-api"
import SimpleTextWidget from "@/components/widgets/SimpleTextWidget.vue"
import {executeQuery} from "@/data/repos/query"

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.Custom(),
    widget: "AuditRoomsNotAudited",
    title: "Rooms not audited",
    cType: "text",
    w: 2,
    h: 2,
    params: {
      auditCategory: {...WParamTpl.auditCategory(), _order: 1},
    },
  }
}

async function titleCallback(config: any) {
  return "Category: " + (config.params.auditCategory.value.title || "<All>")
}

export default defineComponent({
  props: {config: {type: Object, required: true}},
  components: {SimpleTextWidget},
  setup(props, context) {
    context.emit("config-update", config())
    const fromDate = toYYYYMMDD(datePeriodStartDate(new Date(), "1y"))
    const toDate = getTodayYYYYMMDD()

    async function dataFetcher(params: any) {
      const categoryID = params.auditCategory.value.value || 0
      const r = await executeQuery("micad4-audit", "roomsNotAudited",
        {fromDate, toDate, categoryID}) //todo pass all parameters
      return {value: formatNumberWithGrouping(r[0]['totalRoomsNotAudited'])}
    }

    function chartClickCallback() {
      const auditType = 1
      bus.$emit('chartPopup', {
        title: 'Rooms not audited',
        component: () => import('@/components/widgets/audit/AuditAuditedRoomsStatusDrillDown.vue'),
        componentArgs: {
          fromDate: fromDate,
          toDate: toDate,
          auditType: auditType,
          categoryID: props.config.params.auditCategory.value.value,
        },
      })
    }

    return {dataFetcher, chartClickCallback, titleCallback}
  },
})
